import { Button, Stack } from "@mui/material";

import { carrierHasBookingWriteAccess } from "utils";

import {
  useCarrierShipmentPageContext,
  useDisclosure,
} from "../../../../../../../../hooks";
import { MarkShipmentAsDeliveredModal } from "../../../../../../../MarkShipmentAsDeliveredModal";

export function MarkShipmentAsDeliveredButton() {
  const { shipment, onRefresh } = useCarrierShipmentPageContext();
  const {
    isOpen: markShipmentAsDeliveredModalOpen,
    onClose: onCloseMarkShipmentAsDeliveredModal,
    onOpen: onOpenMarkShipmentAsDeliveredModal,
  } = useDisclosure(false);

  if (
    !shipment ||
    !carrierHasBookingWriteAccess(shipment) ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    (shipment.shipment_status !== "BOOKED" &&
      shipment.shipment_status !== "PICKED_UP")
  ) {
    return null;
  }

  return (
    <Stack>
      <Button
        color="success"
        onClick={onOpenMarkShipmentAsDeliveredModal}
        variant="contained"
      >
        Mark Delivered
      </Button>
      <MarkShipmentAsDeliveredModal
        onModalClose={onCloseMarkShipmentAsDeliveredModal}
        modalOpen={markShipmentAsDeliveredModalOpen}
        shipmentId={shipment.info.id}
        onMarkDeliveredSuccess={onRefresh}
        quotingUnitOfMeasure={shipment.info.quoting_unit_of_measure}
      />
    </Stack>
  );
}
